import { render, staticRenderFns } from "./LikeMessage.vue?vue&type=template&id=8d441e9c&scoped=true&"
import script from "./LikeMessage.vue?vue&type=script&lang=js&"
export * from "./LikeMessage.vue?vue&type=script&lang=js&"
import style0 from "./LikeMessage.vue?vue&type=style&index=0&id=8d441e9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d441e9c",
  null
  
)

export default component.exports